import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import ReactApexChart from 'react-apexcharts';
import Header from '../../Header/Header';
import Rightarrow from '../../images/right-arrow.png';
import Leftarrow from '../../images/left-arrow.png';
import Table from './Table/Table';
import Footer from '../../Footer/Footer';
const fetchData = async (url, month) => {
  try {
    const requestData = month ? { month } : {};
    const response = month
      ? await axios.post(url, requestData)
      : await axios.get(url);

    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    return { error: true };
  }
};

const Dashboard_new = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [barChartData, setBarChartData] = useState({
    series: [{ name: 'Subscription Count', data: [] }],
    options: {
      chart: {
        height: 350,
        type: 'bar',
      },
      tooltip: {
        show:false
    },
    
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        title: {
          text: 'Count',
        },
      },
      fill: {
        opacity: 1,
      },
    },
  });

  const [customChartData, setcustomChartData] = useState({
    series: [{ name: 'Custom Chart Data', data: [] }],
    options: {
      chart: {
        height: 350,
        type: 'bar',
      },
      tooltip: {
        show:false
    },
    
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        title: {
          text: 'Count',
        },
      },
      fill: {
        opacity: 1,
      },
    },
  });
  const [lineChartData, setLineChartData] = useState({
    series: [{ name: 'User Counts', data: [] }],
    options: {
      chart: {
        height: 350,
        type: 'line',
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 3,
      },
    
      xaxis: {
        categories: [],
      },
    },
  });

  const modalRef = useRef(null);

  useEffect(() => {
    const fetchDataForBarChart = async () => {
      const url = 'http://mobilewap.beeinnovations.com/boxoffice_app/plan_subscription.php';
      const response = await fetchData(url);
      if (!response.error) {
        const data = response.plan_subscription || [];
        const categories = data.map((item) => item.plan);
        const seriesData = data.map((item) => item.count);
        setBarChartData((prevState) => ({
          ...prevState,
          series: [{ data: seriesData }],
          options: {
            ...prevState.options,
            xaxis: {
              ...prevState.options.xaxis,
              categories: categories,
            },
          },
        }));
      }
    };
    const fetchDataForCustomChart = async () => {
      const url = 'http://mobilewap.beeinnovations.com/boxoffice_app/date_wise_users.php';
      const response = await fetchData(url);
      if (!response.error) {
        const data = response.date_wise_users || [];
        const categories = data.map(item => item.date);
      const seriesData = data.map(item => item.count);
        setcustomChartData((prevState) => ({
          ...prevState,
          series: [{ data: seriesData }],
          options: {
            ...prevState.options,
            xaxis: {
              ...prevState.options.xaxis,
              categories: categories,
            },
          },
        }));
      }
    };

    const fetchDataForLineChart = async () => {
      const url = 'http://mobilewap.beeinnovations.com/boxoffice_app/circle_subscription.php';
      const response = await fetchData(url);
      if (!response.error) {
        const data = response.circle_subscription || [];
        const categories = data.map((item) => item.circle);
        const seriesData = data.map((item) => item.count);
        setLineChartData((prevState) => ({
          ...prevState,
          series: [{ data: seriesData }],
          options: {
            ...prevState.options,
            xaxis: {
              ...prevState.options.xaxis,
              categories: categories,
            },
          },
        }));
      }
    };

    fetchDataForBarChart();
    fetchDataForLineChart();
    fetchDataForCustomChart();
  }, []);

  useEffect(() => {
    const fetchDataForBarChart = async () => {
      const url = 'http://mobilewap.beeinnovations.com/boxoffice_app/plan_subscription.php';
      const response = await fetchData(url, selectedMonth);
      if (!response.error) {
        const data = response.plan_subscription || [];
        const categories = data.map((item) => item.plan);
        const seriesData = data.map((item) => item.count);
        setBarChartData((prevState) => ({
          ...prevState,
          series: [{ data: seriesData }],
          options: {
            ...prevState.options,
            xaxis: {
              ...prevState.options.xaxis,
              categories: categories,
            },
          },
        }));
      }
    };

    const fetchDataForCustomChart = async () => {
      const url = 'http://mobilewap.beeinnovations.com/boxoffice_app/date_wise_users.php';
      const response = await fetchData(url, selectedMonth);
      if (!response.error) {
        const data = response.date_wise_users || [];
        const categories = data.map(item => item.date);
      const seriesData = data.map(item => item.count);
        setcustomChartData((prevState) => ({
          ...prevState,
          series: [{ data: seriesData }],
          options: {
            ...prevState.options,
            xaxis: {
              ...prevState.options.xaxis,
              categories: categories,
            },
          },
        }));
      }
    };

    const fetchDataForLineChart = async () => {
      const url = 'http://mobilewap.beeinnovations.com/boxoffice_app/circle_subscription.php';
      const response = await fetchData(url, selectedMonth);
      if (!response.error) {
        const data = response.circle_subscription || [];
        const categories = data.map((item) => item.circle);
        const seriesData = data.map((item) => item.count);
        setLineChartData((prevState) => ({
          ...prevState,
          series: [{ data: seriesData }],
          options: {
            ...prevState.options,
            xaxis: {
              ...prevState.options.xaxis,
              categories: categories,
            },
          },
        }));
      }
    };

    if (selectedMonth) {
      fetchDataForBarChart();
      fetchDataForLineChart();
      fetchDataForCustomChart();

    }
  }, [selectedMonth]);

  const handleModalClose = () => {
    const fromDate = document.getElementById('fromDate').value;
    setSelectedMonth(fromDate);
    closeModal();
  };

  const closeModal = () => {
    const modal = modalRef.current;
    if (modal) {
      const bootstrapModal = window.$(modal);
      bootstrapModal.modal('hide');
    }
  };

  const SampleNextArrow = (props) => {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <img src={Rightarrow} alt='' width='20px' />
      </div>
    );
  };

  const SamplePrevArrow = (props) => {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <img src={Leftarrow} alt='' width='20px' />
      </div>
    );
  };

  const settings = {
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: activeSlide,
    afterChange: (current) => setActiveSlide(current),
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
  };

  return (
    <div>
      <Header />
      <div className='container-fluid maincontent'>
        <div className='row'>
          <div className='col-lg-2 sidebar_top'>
            <div className='sidebar'>
              <div className='selectbtn'>
                <button className='btn' data-toggle='modal' data-target='#selectPeriodModal'>
                  Select Period
                </button>
              </div>
              <div className='selectbtn'>
                <button className='btn' data-toggle='modal' data-target='#downloadModal'>
                  Download Reports
                </button>
              </div>
            </div>
          </div>
          <div className='col-lg-10 col-md-12 col-sm-12 sai_content'>
            <Slider {...settings}>
              <div>
                <center>
                  <h4 className='sai_responsive_name'>RV Vs ZING User Count Report</h4>
                </center>
                <div className='row '>
                  <div className='tabledesign_row'>
                    <div className='col-lg-6 col-md-6 col-sm-6'>
                      <button className='newonbtn' data-toggle='modal' data-target='#selectPeriodModal'>
                        Select Period
                      </button>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-6 d-flex justify-content-end'>
                      <button className='newonbtn' data-toggle='modal' data-target='#downloadModal'>
                        Download Reports
                      </button>
                    </div>
                  </div>
                </div>
                <div id="bar-chart">
                  <ReactApexChart options={barChartData.options} series={barChartData.series} type="bar" height={350} />
                </div>
                <p className='chart_desc'>
                  Counts of successful delivery of the preactivated ZING service to the bundled RV recharges. The summary
                  report indicates the best performing RV packs till date of the month.
                </p>
              </div>
              <div>
                <center>
                  <h4 className='sai_responsive_name'>Circles Vs ZING User Count Report</h4>
                </center>
                <div id="line-chart">
                  <ReactApexChart options={lineChartData.options} series={lineChartData.series} type="line" height={350} />
                </div>
                <p className='chart_desc'>
                  Circle wise performance of successful delivery of ZING preactivated service url gives insight into the
                  best performing circles; as well as the circles with most potential of market penetration and the
                  circles that are consistent in their performance.
                </p>
              </div>
              <div>
                <center>
                  <h4 className='sai_responsive_name'>ZING Active Users - Datewise Performance Report</h4>
                </center>

                <div id="line-chart">
                  <ReactApexChart options={customChartData.options} series={customChartData.series} type="line" height={350} />
                </div>
                {/* Replace this with your custom chart code or similar logic */}
                <p className='chart_desc'>
                  Datewise performance of ZING active users gives insight into the engagement and retention of users over
                  a period of time.
                </p>
              </div>
            </Slider>
            <div className='row'>
              {/* <Table /> */}
            </div>
            <div className='row'>
              <Footer />
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Select Period */}
      <div className='modal fade' id='selectPeriodModal' tabIndex='-1' role='dialog' aria-labelledby='selectPeriodModalLabel' aria-hidden='true' ref={modalRef}>
        <div className='modal-dialog' role='document'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title' id='selectPeriodModalLabel'>Select Period</h5>
              <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body'>
              <input type='month' id='fromDate' name='fromDate' min='2024-04'   />
            </div>
            <div className='modal-footer'>
              <button type='button' className='btn btn-secondary' data-dismiss='modal'>Close</button>
              <button type='button' className='btn btn-primary' data-dismiss='modal' onClick={handleModalClose}>Save changes</button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Download Reports */}
     
    </div>
  );
};

export default Dashboard_new;
